export class BaseTouroFiltro {

    public bullId: number;
    public breed: string;
    public interregnum: string;
    public name: string;
    public shortname: string;
    public semencode: string;
  }
